import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useCart from '../hooks/useCart';
import { useAllProducts } from '../hooks/useAllProducts';
import '../styles/CartCheckout.css';
import EmptyImage from "../assets/img/mobile-empty-cart.png"
import {BASE_URL} from "../config";
const CartCheckout = ({showToast}) => {
    const { basket, increment, decrement, remove, clearCart, getTotalAmount } = useCart();
    const { allProducts, error: productsError } = useAllProducts();
    const [isLoading, setIsLoading] = useState(true);
    const [isPlacingOrder, setIsPlacingOrder] = useState(false);
    const [stockErrors, setStockErrors] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const checkAuthStatus = () => {
            const userStatus = localStorage.getItem('loggedIn');
            if (userStatus !== 'true') {
                navigate('/login');
                return;
            }
            setIsLoading(false);
        };

        checkAuthStatus();
    }, [navigate]);

    const handlePlaceOrder = async () => {
        setIsPlacingOrder(true);
        try {
            const userToken = localStorage.getItem('userToken');

            const orderData = {
                paymentMethod: 'FastPay',
                items: basket.map(item => ({
                    productId: item.id,
                    quantity: item.quantity,
                    price: item.price
                }))
            };

            const response = await fetch(`${BASE_URL}api/v1/checkout`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${userToken}`,
                    'Accept': 'application/json',
                },
                body: JSON.stringify(orderData),
            });
            

            const result = await response.json();
            console.log("result" , result);

            if (response.ok) {
                // Clear cart on successful order
                // clearCart();

                // Show success message
                // alert('Order placed successfully! Invoice: ' + result.data.invoiceNumber);

                // Redirect to order confirmation
                // showToast('Order placed successfully!');
                const paymentUrl = result.data.paymentUrl;

                if (!paymentUrl) {
                    throw new Error("Payment URL not provided by server!");
                }

                clearCart();
                const checkoutId = result.data.checkoutId;
                const integrity = result.data.integrity;
                const shopperResultUrl = `http://localhost/public/api/v1/payment/callback`; 

                navigate('/payment', {
                     replace: true,
                    state: { checkoutId, shopperResultUrl ,integrity }
                });
                // window.location.href = paymentUrl;
                // navigate('/', {
                //     state: {
                //         invoiceNumber: result.data.invoiceNumber,
                //         totalAmount: result.data.totalAmount
                //     }
                // });
            } else {
                // Handle stock errors
                if (result.outOfStockProducts) {
                    setStockErrors(result.outOfStockProducts);
                    // Remove out of stock items from cart automatically
                    const updatedBasket = basket.filter(item =>
                        !result.outOfStockProducts.some(
                            outOfStock => outOfStock.product ===
                                allProducts.find(p => p.id === item.id)?.name
                        )
                    );

                    // Update basket if we automatically removed items
                    if (updatedBasket.length !== basket.length) {
                        localStorage.setItem('basket', JSON.stringify(updatedBasket));
                        window.location.reload(); // Refresh to update UI
                    }

                    throw new Error('Some products are out of stock. They have been removed from your cart.');
                }

                throw new Error(result.message || 'Failed to place order');
            }
        } catch (error) {
            console.error('Checkout error:', error);
            alert('Error placing order: ' + error.message);
        } finally {
            setIsPlacingOrder(false);
        }
    };

    const handleRemoveOutOfStock = () => {
        // Remove all items that are in the stockErrors list
        const updatedBasket = basket.filter(item =>
            !stockErrors.some(
                error => error.product === allProducts.find(p => p.id === item.id)?.name
            )
        );

        localStorage.setItem('basket', JSON.stringify(updatedBasket));
        setStockErrors([]);
        window.location.reload(); // Refresh to update UI
    };

    if (isLoading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (productsError) {
        return (
            <div className="alert alert-danger m-3">
                Error loading products: {productsError}
            </div>
        );
    }

    const grandTotal = getTotalAmount();

    const handleIncrement = (productId) => {
        // Find the product to get its current price
        const product = allProducts.find(p => p.id === productId);
        if (product) {
            const price = product.discount > 0
                ? product.price - (product.price * product.discount) / 100
                : product.price;

            increment(productId, price);
        }
    };

    const handleDecrement = (productId) => {
        decrement(productId);
    };

    const handleRemove = (productId) => {
        remove(productId);
    };


    return (
        <div className="cart-checkout-page">
            {/* Cart Checkout Content */}
            <div className="cart-checkout section-padding container">
                {stockErrors.length > 0 && (
                    <div className="alert alert-warning">
                        <h5>Inventory Issues</h5>
                        <p>Some products in your cart are out of stock or have insufficient quantity:</p>
                        <ul>
                            {stockErrors.map((error, index) => (
                                <li key={index}>
                                    <strong>{error.product}</strong>:
                                    Requested {error.requested}, Available {error.available}
                                </li>
                            ))}
                        </ul>
                        <button
                            className="btn btn-outline-danger btn-sm"
                            onClick={handleRemoveOutOfStock}
                        >
                            Remove Out of Stock Items
                        </button>
                    </div>
                )}

                <div className="row gap-5 gap-md-0">
                    <div className="col-md-8">
                        <h4 className="mb-3 mb-md-4 text-color-bright text-center">My Cart</h4>
                        <div className="cart-products">
                            {basket.length > 0 ? (
                                <>
                                    {basket.map(cartItem => {
                                        const productDetails = allProducts.find(p => p.id === cartItem.id);
                                        if (!productDetails) return null;

                                        const discountedPrice = productDetails.discount > 0
                                            ? productDetails.price - (productDetails.price * productDetails.discount) / 100
                                            : productDetails.price;

                                        const totalPrice = discountedPrice * cartItem.quantity;

                                        return (
                                            <div key={cartItem.id} className="cart-middle d-flex align-items-center gap-2 mb-4 p-3 bg-light rounded">
                                                <div className="selected-item-left position-relative">
                                                    <h6 className="price position-absolute top-0 bg-text mb-0 p-1">
                                                        {discountedPrice.toLocaleString()} IQD
                                                    </h6>
                                                    <img
                                                        src={`https://akadgatepharmacy.com/backend/storage/app/public${productDetails.featuredImage.replace("/storage", "")}`}
                                                        alt={productDetails.name}
                                                        className="img-fluid rounded"
                                                        style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                                                    />
                                                </div>
                                                <div className="selected-item-middle d-flex flex-column justify-content-between flex-grow-1">
                                                    <h5 className="m-0">{productDetails.name}</h5>
                                                    <p className="m-0 text-truncate small">{productDetails.description}</p>
                                                    <h6 className="m-0 mt-2">{totalPrice.toLocaleString()} IQD</h6>
                                                </div>
                                                <div className="selected-item-right d-flex flex-column justify-content-between align-items-center">
                                                    <div className="quantity-control text-center">
                                                        <button
                                                            type="button"
                                                            onClick={() => handleIncrement(cartItem.id)}
                                                            className="bg-transparent p-0 border-0"
                                                            aria-label='Increase quantity'
                                                        >
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                className="icon icon-tabler icon-tabler-chevron-up"
                                                                width="24"
                                                                height="24"
                                                                viewBox="0 0 24 24"
                                                                strokeWidth="1.5"
                                                                stroke="#000000"
                                                                fill="none"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            >
                                                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                                <path d="M6 15l6 -6l6 6" />
                                                            </svg>
                                                        </button>
                                                        <h6 className="my-2">{cartItem.quantity}</h6>
                                                        <button
                                                            type="button"
                                                            onClick={() => handleDecrement(cartItem.id)}
                                                            className="bg-transparent p-0 border-0"
                                                        >
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                className="icon icon-tabler icon-tabler-chevron-down"
                                                                width="24"
                                                                height="24"
                                                                viewBox="0 0 24 24"
                                                                strokeWidth="1.5"
                                                                stroke="#000000"
                                                                fill="none"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            >
                                                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                                <path d="M6 9l6 6l6 -6" />
                                                            </svg>
                                                        </button>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        onClick={() => handleRemove(cartItem.id)}
                                                        className="bg-transparent p-0 border-0 mt-2"
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            className="icon icon-tabler icon-tabler-trash-x"
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            strokeWidth="1.5"
                                                            stroke="#000000"
                                                            fill="none"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        >
                                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                            <path d="M4 7h16" />
                                                            <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                                                            <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                                                            <path d="M10 12l4 4m0 -4l-4 4" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        );
                                    })}
                                    <div className="cart-bottom mt-4 text-center">
                                        <h6 className="mt-3 mb-3 fw-bold">
                                            SUBTOTAL: {grandTotal.toLocaleString()} IQD
                                        </h6>
                                        <hr />
                                        <button
                                            type="button"
                                            onClick={clearCart}
                                            className="btn btn-danger me-2"
                                        >
                                            Clear Cart
                                        </button>
                                        <Link to="/shop" className="btn btn-primary">
                                            Shop More
                                        </Link>
                                    </div>
                                </>
                            ) : (
                                <div className="empty-cart text-center py-5">
                                    <h4>Cart is Empty</h4>
                                    <p>It Seems You Haven't Added Any Product To Your Cart Yet</p>
                                    <img src={EmptyImage} alt="Empty Cart" height="64" width="64" className="my-3" />
                                    <Link to="/" className="btn btn-primary">
                                        Shop Now
                                    </Link>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="col-md-4">
                        <h4 className="mb-3 mb-md-4 text-color-bright text-center">Order Summary</h4>
                        <div className="order-summary p-3 bg-light rounded">
                            <div className="delivery d-flex justify-content-between align-items-center mb-2 p-2">
                                <h6 className="m-0">Delivery:</h6>
                                <h6 className="value m-0">free</h6>
                            </div>
                            <div className="total d-flex justify-content-between align-items-center mb-3 p-2">
                                <h5 className="m-0">Grand Total:</h5>
                                <h6 className="value m-0 fw-bold">
                                    {grandTotal.toLocaleString()} IQD
                                </h6>
                            </div>
                            <button
                                type="button"
                                className="btn pay-btn w-100"
                                onClick={handlePlaceOrder}
                                disabled={basket.length === 0 || isPlacingOrder}
                            >
                                {isPlacingOrder ? 'Processing...' : 'Place Order'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Return Policy Modal */}
            <div className="modal fade" id="returnPolicyModal" tabIndex="-1" aria-labelledby="returnPolicyModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="returnPolicyModalLabel">Return of Product Policy</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <p>At AKAD Gate Pharmacy, we understand that sometimes returns are necessary. We strive to ensure your satisfaction with every purchase. Please review our return policy below:</p>
                            <p>Returns will be accepted on the same day of purchase, provided that the seal of the product remains unbroken.</p>
                            <p>To initiate a return, please contact our customer service team within the same day of purchase to notify us of the return request.</p>
                            <p>Products must be returned in their original packaging, with all included accessories and documentation.</p>
                            <p>Returns may be subject to a cost of delivery, which will be deducted from the refund amount.</p>
                            <p>Refunds will be issued in the original form of payment upon receipt and inspection of the returned product.</p>
                            <p>Please note that certain products may not be eligible for return due to health and safety regulations. This includes but is not limited to prescription medications and perishable items.</p>
                            <p>AKAD Gate Pharmacy reserves the right to refuse returns that do not meet the above criteria or are deemed to be ineligible for return.</p>
                            <p>We strive to make the return process as smooth and hassle-free as possible. If you have any questions or concerns regarding our return policy, please don't hesitate to contact our customer service team for assistance.</p>
                            <p>Thank you for choosing AKAD Gate Pharmacy. We appreciate your business and look forward to serving you again in the future.</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CartCheckout;